<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
// import Vue from 'vue'
// import Info from './info.vue'
// import Repair from './repair.vue'
// import Track from './track.vue'
export default {
  extends: baseList,
  components: {
    // info: Info,
    // Repair,
    // Track,
  },
  data() {
    return {
      table: {
        mname: "sysLog",
        key: "id",
        url: {
          // del: '/admin/system/desk'
        },
        output: false,
      },
      actions: [
        // {
        //   label: '新增科室',
        //   icon: 'md-add',
        //   onClick: this.toAdd,
        //   auth: '',
        // },
        // {
        //   label: '导入',
        //   icon: 'md-add',
        //   onClick: this.toImport,
        //   auth: '',
        // },
        // {
        //   label: '下载模板',
        //   icon: '',
        //   onClick: this.toDownload,
        //   auth: '',
        // },
      ],
      menus: [
        // {
        //   label: "配置列表",
        //   name: "configure_list",
        //   auth: "/admin/configure/lists",
        // },
        // {
        //   label: "坐席列表",
        //   name: "callConfig_list",
        //   auth: "/admin/callConfig/lists",
        // },
        // {
        //   label: "公告列表",
        //   name: 'notice_list',
        //   auth: '/admin/configure/lists',
        // },
        // {
        //   label: "操作日志",
        //   name: "operlog_list",
        //   auth: "/admin/operlog/lists",
        // },
        // {
        //   label: "登录日志",
        //   name: "logininfor_list",
        //   auth: "/admin/logininfor/lists",
        // },

        // {
        //   label: "投诉管理",
        //   name: "feedback_list",
        //   auth: "/admin/feedback/lists",
        // },
      ],
      filters: [
        {
          label: "登陆地址",
          name: "ipaddr",
          value: "",
          type: "input",
        },
        {
          label: "用户名称",
          name: "userName",
          value: "",
          type: "input",
        },
        {
          label: "登陆状态",
          name: "status",
          value: "",
          type: "select",
          dropList: [
            {
              value: 0,
              name: "成功",
            },
            {
              value: 1,
              name: "失败",
            },
          ],
        },
      ],
      tableCols: [
        {
          title: "日志编号",
          key: "infoId",
          minWidth: 120,
          align: "center",
        },
        {
          title: "用户名称",
          key: "userName",
          minWidth: 120,
          align: "center",
        },
        {
          title: "操作系统",
          key: "os",
          minWidth: 120,
          align: "center",
        },
        {
          title: "浏览器",
          key: "browser",
          minWidth: 120,
          align: "center",
        },
        {
          title: "登录地址",
          key: "ipaddr",
          minWidth: 120,
          align: "center",
        },
        {
          title: "登录时间",
          width: 115,
          align: "center",
          key: "loginTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.loginTime.slice(0, 16);
            return <span>{text}</span>;
          },
        },
        {
          title: "登录状态",
          key: "status",
          width: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const color =
              row.status == 0 ? "blue" : row.status == 1 ? "red" : "";
            const text =
              row.status == 0 ? "成功" : row.status == 1 ? "失败" : "";
            return (
              <span style={{ color: color, "font-size": "14px" }}>{text}</span>
            );
          },
        },
        {
          title: "操作信息",
          width: 120,
          align: "center",
          key: "msg",
          tooltip:true
        },
        //  {
        //               title: '操作',
        //               align: 'center',
        //               width: 160,
        //               key: 'handle',
        //               handle: [
        //                 // 'edit',
        //                 // 'delete'
        //                 ]
        //           }
      ],
    };
  },
  created() {
    this.loadLevelData();
  },
  methods: {
    loadLevelData() {
      // 通过pk查询字典数据
      let q = {};
      // q.state=1
      $utils.api.load("/admin/system/desk/selectList", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.deskName;
            xx.name = element.deskName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "deskName") {
              this.filters[index]["dropList"] = (
                element["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    // toAdd() {
    //   $utils.url.push({ name: 'offices_add', query: { action: 'add' } })
    // },
    //  handleEdit(currentRow){
    //   $utils.url.push({ name: "offices_edit", query: {action: "edit",kv:currentRow.id } });
    // },
    //转单
    // toChange(row) {},
    //详情
    // toInfo(row) {
    //   $utils.url.push({
    //     name: 'knowledgeBase_info',
    //     query: { action: 'edit', kv: row.id },
    //   })
    // },
    //导出
    toImport() {},
    //下载模板
    toDownload() {},
  },
};
</script>
<style scoped></style>
